import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ComponentsFactory from 'foundation/components-factory';

class Banner extends React.Component {
    constructor(...args) {
        super(...args);
        this.rootRef = React.createRef();
    }

    componentDidMount() {
        ComponentsFactory.getInstance().init(this.rootRef.current);
    }

    componentWillUnmount() {
        ComponentsFactory.getInstance().destroy(this.rootRef.current);
    }

    render() {
        const { model, theme } = this.props;

        if (!model) return null;

        const bemCss = classNames({
            banner: true,
            'banner--landscape': theme.isLandscape,
            'banner--portrait': theme.isPortrait,
            'banner--contextual': theme.isContextual,
        });

        return (
            <div
                className={bemCss}
                data-dc-component="banner"
                data-dc-banner-options={JSON.stringify(model)}
                ref={this.rootRef}></div>
        );
    }
}

Banner.defaultProps = {
    theme: {
        isLandscape: true,
    }
};

Banner.propTypes = {
    model: PropTypes.shape({
        country: PropTypes.string,
        endpointUrl: PropTypes.string,
        category: PropTypes.string,
        action: PropTypes.string,
        pageName: PropTypes.string
    }),
    theme: PropTypes.shape({
        isLandscape: PropTypes.bool,
        isPortrait: PropTypes.bool,
        isContextual: PropTypes.bool
    })
};

export default Banner;
